import React, { useState, useEffect, createContext, useContext } from 'react';
import axios from 'axios';
import { API } from '../utils/api';

const CommunityAuthContext = createContext(null);

export const useCommunityAuth = () => {
  const context = useContext(CommunityAuthContext);
  if (!context) throw new Error('useCommunityAuth must be used within CommunityAuthProvider');
  return context;
};

export const CommunityAuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('community_token'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchUser();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchUser = async () => {
    try {
      const res = await axios.get(`${API}/community/users/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setUser(res.data);
    } catch {
      localStorage.removeItem('community_token');
      setToken(null);
      setUser(null);
    } finally {
      setLoading(false);
    }
  };

  const login = (newToken, userData) => {
    localStorage.setItem('community_token', newToken);
    setToken(newToken);
    setUser(userData);
  };

  const logout = () => {
    localStorage.removeItem('community_token');
    localStorage.removeItem('community_onboarding');
    setToken(null);
    setUser(null);
  };

  const isAdmin = user?.role === 'COMMUNITY_ADMIN';

  return (
    <CommunityAuthContext.Provider value={{ user, token, loading, login, logout, refreshUser: fetchUser, isAdmin }}>
      {children}
    </CommunityAuthContext.Provider>
  );
};
